import { render, staticRenderFns } from "./ShippingHeading.vue?vue&type=template&id=4693185c&"
import script from "./ShippingHeading.vue?vue&type=script&lang=ts&"
export * from "./ShippingHeading.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingHeading.vue?vue&type=style&index=0&id=4693185c&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports